import { useTranslations } from "@fenetech/translations";
import { Grid } from "@mui/material";
import AutocompleteMultiSelectForm from "components/Common/AutocompleteMultiSelectForm";
import CheckBoxForm from "components/Common/CheckBoxForm";
import { IAssignableUser } from "models/IWebCustomer";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";

interface IProps {
    assignableUsers: IAssignableUser[],
    readOnly: boolean
}

const AssignableUsers: React.FC<IProps> = ({ assignableUsers, readOnly }: IProps) => {

    const formMethods = useFormContext();
    const { watch } = formMethods;

    const tm = useTranslations();
    const allUsersChecked: boolean = watch("isAllUsers");

    const optionDisabled = useCallback((option: IAssignableUser) => {
        return option.isSalesPerson || option.isAllCustomers;
    }, []);

    const optionTooltip = useCallback((option: IAssignableUser) => {
        let tooltipLines: string[] = [];
        if (option.isSalesPerson)
            tooltipLines.push("User is the salesperson");
        if (option.isAllCustomers)
            tooltipLines.push("User is assigned to all customers");
        if (option.inactive)
            tooltipLines.push("User Inactive");
        return tooltipLines.join("\n");
    }, []);

    const optionTooltipIsWarning = useCallback((option: IAssignableUser) => {
        return option.inactive;
    }, []);

    return <>
        {(!readOnly) &&
            <Grid item xs={12}>
                <CheckBoxForm
                    fieldName="isAllUsers"
                    label={tm.Get("All Users")}
                    readOnly={readOnly}
                />
            </Grid>
        }
        <Grid item xs={12}>
            <AutocompleteMultiSelectForm
                dataSource={assignableUsers}
                isAllSelected={allUsersChecked}
                fieldName="assignedUsers"
                valueField="employeeID"
                displayField="userName"
                translateDisplayField={false}
                label={tm.Get("Assigned Users")}
                readOnly={readOnly}
                size="medium"
                optionDisabled={optionDisabled}
                optionTooltip={optionTooltip}
                optionTooltipIsWarning={optionTooltipIsWarning}
            />
        </Grid>
    </>;
}

export default AssignableUsers;